import React from 'react'
import { RenderHTMLProps } from './RenderHTML.types'
import { twMerge } from 'tailwind-merge'
import { Theme } from './RenderHTML.theme'

export const sanitizeHtml = (html?: string): string => {
  if (!html) return '';

  let sanitized = html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
    .replace(/<(iframe|object|embed|applet|meta|link|base|form)\b[^>]*>/gi, '')
    .replace(/<\/(iframe|object|embed|applet|meta|link|base|form)>/gi, '')
    .replace(/\s*on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/(href|src)\s*=\s*["']?\s*javascript:[^"'>\s]*/gi, '');

  const hasHtmlTags = /<[a-z][\s\S]*>/i.test(sanitized);
  if (!hasHtmlTags) {
    return sanitized.replace(/\r\n|\r|\n/g, '<br />');
  }

  return sanitized
    .replace(/\s*[\r\n]+\s*(<\/?(?:ol|ul|li|p|div|h[1-6]|table|tr|td|th|tbody|thead|blockquote|br)[^>]*>)/gi, '$1')
    .replace(/(<\/?(?:ol|ul|li|p|div|h[1-6]|table|tr|td|th|tbody|thead|blockquote)[^>]*>)\s*[\r\n]+\s*/gi, '$1');
};

export const RenderHTML = ({content = "", className}: RenderHTMLProps) => {
  return (
    <div 
        className={twMerge([Theme.wrapper, className])} 
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }} />
  )
}

